import { render, staticRenderFns } from "./member-center.vue?vue&type=template&id=18416a80&scoped=true"
import script from "./member-center.vue?vue&type=script&lang=js"
export * from "./member-center.vue?vue&type=script&lang=js"
import style0 from "./member-center.vue?vue&type=style&index=0&id=18416a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18416a80",
  null
  
)

export default component.exports